import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlightPipe'
})
export class HighlightPipe implements PipeTransform {

  transform(value: any, args: any): any {
    if (args != null) {
      if (!args) { 
        return value; 
      }
    }
    var re = new RegExp(args, 'gi'); //'gi' for case insensitive and can use 'g' if you want the search to be case sensitive.
    if (value != null) {
      return value.toString().replace(re, "<mark>$&</mark>");
    }
    // return value.replace(re,"<mark>$&</mark>"); -- older code
  }
}
